module.exports = __webpack_public_path__ + "static/media/concluido.9eebcc30.svg";